import { Box, Typography } from '@mui/material';

type Tokens = { font: string; ink: string; muted: string };

export function LoadFailure({ tokens }: { tokens: Tokens }) {
  return (
    <Box sx={{ px: '16px', pb: '24px', textAlign: 'center' }}>
      <Typography
        data-testid="data-load-failed"
        sx={{ fontFamily: tokens.font, fontSize: 16, lineHeight: '24px', color: tokens.ink }}
      >
        We could not load your data.
      </Typography>
      <Typography
        sx={{ fontFamily: tokens.font, fontSize: 13, lineHeight: '20px', color: tokens.muted }}
      >
        Nothing has been lost. Refresh the page to try again.
      </Typography>
    </Box>
  );
}
